import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { toast } from 'react-toastify';

const AdminRoute = ({ children }) => {
  const { auth } = useAuth();

  const hasToken = !!auth.token;
  const isAdmin = (auth.role === 'ROLE_ADMIN' || auth.role === 'ROLE_SUPERADMIN');


  if (hasToken && isAdmin) {
    return children;
  } else {
    toast.error('Rättigheter saknas.', { position: 'bottom-right' });
    return <Navigate to="/" />;
  }
};

export default AdminRoute;
